import * as React from "react";
import { prettifyAiOutput, PrettifyAiOutputResponse } from "./aiRequestsApi";

export interface PrettifiedEntry {
    status: 'loading' | 'done' | 'error';
    text?: string;
    compact?: string | null;
    isJson?: boolean;
    error?: string;
}


export function usePrettifier() {
    const [entries, setEntries] = React.useState<Record<string, PrettifiedEntry>>({});
    const known = React.useRef<Set<string>>(new Set());

    const ensure = React.useCallback((key: string, text: string) => {
        if (!text || known.current.has(key)) return;
        known.current.add(key);
        setEntries(prev => ({ ...prev, [key]: { status: 'loading' } }));

        prettifyAiOutput(text)
            .then((res: PrettifyAiOutputResponse) => setEntries(prev => ({
                ...prev,
                [key]: { status: 'done', text: res.prettified, compact: res.compact, isJson: res.isJson }
            })))
            .catch((e: any) => setEntries(prev => ({
                ...prev,
                [key]: { status: 'error', error: e?.message || 'Formatting failed' }
            })));
    }, []);

    const invalidate = React.useCallback((key: string) => {
        known.current.delete(key);
        setEntries(prev => {
            const next = { ...prev };
            delete next[key];
            return next;
        });
    }, []);

    const reset = React.useCallback(() => {
        known.current.clear();
        setEntries({});
    }, []);

    return { entries, ensure, invalidate, reset };
}